import React, { useEffect } from 'react';
import logo from '../../logo.png';
import { Text } from '../../hooks/language';
import styles from './header.module.scss';
import { Box } from '@mui/system';
import { Button, Grid, IconButton, Drawer, Typography } from '@mui/material';
import { ChartSquare, ClipboardText, Personalcard, People, UserSearch, HambergerMenu, CloseSquare } from 'iconsax-react';
import ProfileActions from './profile-actions';
import NotificationPopUp from './notification';
import HeaderUiStore from './header-ui-store';
import withContext from '../../context';
import { useHistory } from "react-router-dom";
import { observer } from 'mobx-react';

const uiStore = new HeaderUiStore();

const Header = observer(({ page, window, context }) => {
  const history = useHistory();
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };
  const container = window !== undefined ? () => window().document.body : undefined;

  useEffect(() => {
    async function fetchData() {
      uiStore.initliazeContext(context);
      if (context.authenticatedUser.id) {
        uiStore.getNotifications();
        uiStore.getUserCode();
      }
    }

    fetchData();
  }, [context]);

  const { user } = uiStore;

  const navButtons =
    !!context.authenticatedUser.id ?
      <>
        <Button
          color={page === 'dashboard' ? 'secondary' : 'greyPrimary'}
          href="/dashboard"
          className={styles.headerLink}
        >
          <ChartSquare
            size="24"
            variant="Bulk"
          />
          <Text tid="Dashboard" />
        </Button>
        <Button
          variant='text'
          color={page === 'my-data' ? 'secondary' : 'greyPrimary'}
          href="/my-data"
          className={styles.headerLink}
        >
          <ClipboardText
            size="24"
            variant="Bulk"
          />
          <Text tid="My Data" />
        </Button>
        <Button
          color={page === 'cards' ? 'secondary' : 'greyPrimary'}
          href="/cards"
          className={styles.headerLink}
        >
          <Personalcard
            size="24"
            variant="Bulk"
          />
          <Text tid="My Cards" />
        </Button>
        <Button
          color={page === 'contacts' ? 'secondary' : 'greyPrimary'}
          href="/contacts"
          className={styles.headerLink}
        >
          <People
            size="24"
            variant="Bulk"
          />
          <Text tid="Contacts" />
        </Button>
        <Button
          color={page === 'find-people' ? 'secondary' : 'greyPrimary'}
          href="/find-people"
          className={styles.headerLink}
        >
          <UserSearch
            size="24"
            variant="Bulk"
          />
          <Text tid="Find People" />
        </Button>
      </>
      :
      <>
        <Button
          color={page === 'find-people' ? 'secondary' : 'greyPrimary'}
          href="/find-people"
          className={styles.headerLink}
        >
          <UserSearch
            size="24"
            variant="Bulk"
          />
          <Text tid="Find People" />
        </Button>
      </>
    ;


  return (
    <Box className={styles.header}>
      <Grid container className={styles.headerContainer} columnSpacing={{ xs: 0, sm: 0 }}>

        <Grid sx={{ ml: 3, mt: 1 }} item xl={1} lg={1} md={2} sm={6} xs={6} className={styles.headerLogo}>
          <Box sx={{ mr: 1, mt: 2 }} display={{ xl: 'none', lg: 'none', md: 'none', sm: 'block', xs: 'block' }}>
            <IconButton onClick={handleDrawerToggle}>
              <Box className={styles.boxButton}>
                <HambergerMenu
                  size="24"
                  color='#242333'
                />
              </Box>
            </IconButton>
          </Box>
          <Box component="nav">
            <Drawer
              container={container}
              variant="temporary"
              open={mobileOpen}
              onClose={handleDrawerToggle}
              ModalProps={{
                keepMounted: true, // Better open performance on mobile.
              }}
              sx={{
                display: { xs: 'block', sm: 'block' },
                '& .MuiDrawer-paper': { boxSizing: 'border-box', width: '300px' },
              }}
            >
              <Box className={styles.mobileMenuHeader}>
                <IconButton sx={{ ml: 2, mr: 1 }} onClick={handleDrawerToggle}>
                  <CloseSquare
                    size="36"
                    color='#242333'
                    variant='Bold'
                  />
                </IconButton>
                <Typography variant='h5' fontWeight='700'>Menu</Typography>
              </Box>
              {navButtons}
            </Drawer>
          </Box>
          <a href="/">
            <img className="logo" src={logo} alt='logo' />
          </a>
        </Grid>

        <Grid container xl={5} lg={6} md={7} sm={6} display={{ md: 'flex', sm: 'none', xs: 'none' }} item className={styles.headerLinks}>
          {navButtons}
        </Grid>

        <Grid sx={{ mr: 3 }} xl={1} lg={1} md={2} sm={1} xs={2} item className={styles.sideLinks}>
          {!!context.authenticatedUser.id ?
            <>
              <NotificationPopUp uiStore={uiStore} />
              <ProfileActions user={user} />
            </>
            :
            <>
              <Button color='secondary' onClick={() => history.push('/login')}>Login</Button>
            </>
          }
        </Grid>

      </Grid>
    </Box>
  );
});

export default withContext(Header);
